export enum OAuthConstants {
  PARAM_KEY_CLIENT_ID = 'client_id',
  PARAM_KEY_CLIENT_SECRET = 'client_secret',
  PARM_KEY_GRANT_TYPE = 'grant_type',
  PARAM_KEY_AUDIENCE = 'audience',
  PARAM_KEY_SCOPE = 'scope',

  PARAM_VALUE_GRANT_TYPE_CLIENT_CREDENTIALS = 'client_credentials',
  PARAM_VALUE_AUDIENCE = 'edge-service',
  PARAM_VALUE_SCOPE = 'offline openid',
}
